// App Config

const pjson = require('../package.json');

const VERSION = pjson.version + '.' + pjson.sprint + '.' + pjson.build;
const MAP_ICON = {
    default: undefined,
    property: 'https://maps.google.com/mapfiles/ms/micons/red-dot.png',
    contractorNoReply: 'http://maps.google.com/mapfiles/kml/paddle/wht-circle-lv.png',
    contractorAccepted: 'http://maps.google.com/mapfiles/kml/paddle/grn-circle-lv.png',
    contractorDeclined: 'http://maps.google.com/mapfiles/kml/paddle/red-circle-lv.png',
    contractorSomeDeclined: 'http://maps.google.com/mapfiles/kml/paddle/blu-circle-lv.png',
};
const COLOR = {
    darkNavy: '#0e2248',
    navy: '#17335d',
    motiliLightBlue: '#57c1e9',
    blue: '#05a6e6',
    green: '#15b039',
    white: '#FFFFFF',
    black: '#000000',
    orange: '#fc6d17',
    red: '#e63232',
    yellow: '#fcb817',
    darkGray: '#3b3b3b',
    mediumGray: '#818181',
    lightGray: '#e9e9e9'
};
const config = {
    local: {
        version: VERSION,
        mapIcon: MAP_ICON,
        color: COLOR,
        microSitesBase: 'http://localhost:9002',
        s2UrlBase: 'http://localhost:3000',
        googleReviewUrl: 'https://g.page/Motili-inc/review?gm'
    },
    dev: {
        version: VERSION,
        mapIcon: MAP_ICON,
        color: COLOR,
        microSitesBase: 'http://m.motilidev.com',
        s2UrlBase: 'https://s2.motilidev.com',
        googleReviewUrl: 'https://g.page/Motili-inc/review?gm'
    },
    dev2: {
        version: VERSION,
        mapIcon: MAP_ICON,
        color: COLOR,
        microSitesBase: 'http://m2.motilidev.com',
        s2UrlBase: 'https://api2.motilidev.com',
        googleReviewUrl: 'https://g.page/Motili-inc/review?gm'
    },
    dev2cs: {
        version: VERSION,
        mapIcon: MAP_ICON,
        color: COLOR,
        microSitesBase: 'http://m2sandbox.motilidev.com',
        s2UrlBase: 'https://sandbox-api.motilidev.com',
        googleReviewUrl: 'https://g.page/Motili-inc/review?gm'
    },
    qa: {
        version: VERSION,
        mapIcon: MAP_ICON,
        color: COLOR,
        microSitesBase: 'http://m.motilitest.com',
        s2UrlBase: 'https://s2.motilitest.com',
        googleReviewUrl: 'https://g.page/Motili-inc/review?gm'
    },
    stage: {
        version: VERSION,
        mapIcon: MAP_ICON,
        color: COLOR,
        microSitesBase: 'http://m.motilistage.com',
        s2UrlBase: 'https://s2.motilistage.com',
        googleReviewUrl: 'https://g.page/Motili-inc/review?gm'
    },
    prod: {
        version: VERSION,
        mapIcon: MAP_ICON,
        color: COLOR,
        microSitesBase: 'http://m.motili.com',
        s2UrlBase: 'https://s2.motili.com',
        googleReviewUrl: 'https://g.page/Motili-inc/review?gm'
    }
};

module.exports = config[ENV]; // ENV is defined by webpack during packaging



// WEBPACK FOOTER //
// ./src/Config.js